import React from 'react';
import styles from './Certificate.module.css';

// Certificate ID: PRREPX-<YYYYMMDD-HHmmss> based on the completion date/time
function buildCertId(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `PRREPX-${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

/**
 * Premium certificate of subject completion.
 * Ornate gold frame · serif typography · laurel seal · signature + stamp.
 */
const Certificate = ({ studentName = '', title = '', subtitle = '', hue = '#021d6d', hue2 = '#011548', date = '', emoji = '🏆', compact = false }) => {
  const completedAt = date ? new Date(date) : new Date();
  const dateLabel = completedAt.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  const certId = buildCertId(completedAt);

  // Professional best-wish line tailored to the exam track
  const t = (title || '').toLowerCase();
  const exam =
    t.includes('jee') ? 'your IIT-JEE examination' :
    t.includes('neet') ? 'your NEET examination' :
    /class\s*1[12]/.test(t) ? 'your board & competitive examinations' :
    'your academic journey';
  const wish = subtitle || `We wish you continued success and the very best in ${exam}.`;

  return (
    <div className={`${styles.certificate} ${compact ? styles.compact : ''}`} style={{ '--hue': hue, '--hue2': hue2 }}>
      <div className={styles.goldFrame}>
        <div className={styles.innerFrame}>
          {/* corner ornaments */}
          <span className={`${styles.corner} ${styles.cTL}`}>❧</span>
          <span className={`${styles.corner} ${styles.cTR}`}>❧</span>
          <span className={`${styles.corner} ${styles.cBL}`}>❧</span>
          <span className={`${styles.corner} ${styles.cBR}`}>❧</span>

          {/* Header */}
          <div className={styles.header}>
            <img className={styles.logo} src="/PrepXPathshala_logo.jpg" alt="PrrepX Pathshala" />
            <span className={styles.brand}>PrrepX Pathshala</span>
            <span className={styles.certType}>Certificate of Completion</span>
            <span className={styles.rule}><i />★<i /></span>
          </div>

          {/* Body */}
          <p className={styles.presented}>This certificate is proudly presented to</p>
          <h3 className={styles.studentName}>{studentName || 'Student'}</h3>
          <span className={styles.nameRule} />
          <p className={styles.forText}>for successfully completing all chapters of</p>
          <h4 className={styles.title}>{title}</h4>
          <p className={styles.wishLine}>{wish}</p>

          {/* Laurel seal */}
          <div className={styles.sealWrap}>
            <span className={styles.sealLaurel}>🏅</span>
          </div>

          {/* Footer */}
          <div className={styles.footer}>
            <div className={styles.sig}>
              <img className={styles.signImg} src="/sign.png" alt="Authorized signatory signature" />
              <span className={styles.sigLine} />
              <span className={styles.sigLabel}>Authorized Signatory</span>
              <span className={styles.sigOrg}>PRREPX PATHSHALA PVT. LTD.</span>
            </div>
            <div className={styles.sig}>
              <img className={styles.stampImg} src="/stamp.png" alt="Company stamp" />
              <span className={styles.sigLine} />
              <span className={styles.sigLabel}>Completed on {dateLabel}</span>
            </div>
          </div>

          <div className={styles.certIdRow}>
            <span className={styles.certIdLabel}>Certificate ID</span>
            <span className={styles.certIdValue}>{certId}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
